// Root
import Home from '../pages/index';
import Components from '../pages/components';

// About pages
import AboutUs from '../pages/about-us/index';
import Careers from '../pages/about-us/careers';
import Media from '../pages/about-us/media';
import ContactUs from '../pages/contact-us/index';
import ContactUsSuccess from '../pages/contact-us/success';

// Industries
import Industries from '../pages/industries/index';
import Government from '../pages/industries/government/index';
import Commercial from '../pages/industries/commercial/index';
import Researchers from '../pages/industries/commercial/researchers';
import InsuranceAndPayers from '../pages/industries/commercial/insurance-and-payers';
import Pharmaceuticals from '../pages/industries/commercial/pharmaceuticals';
import Bioinformatics from '../pages/industries/government/bioinformatics';
import PublicHealthPolicy from '../pages/industries/government/public-health-and-policy';
import NationalSecurity from '../pages/industries/government/national-security';
import PublicSectorSolutions from '../pages/industries/government/public-sector-solutions';
import CustomInformatics from '../pages/industries/commercial/custom-informatics';
import SportsMedicine from '../pages/industries/commercial/sports-medicine';

// Innovation
import Innovation from '../pages/innovation/index';
import Curo46 from '../pages/innovation/curo46';
import CuroSygnal from '../pages/innovation/curosygnal';
import Syn46 from '../pages/innovation/syn46';
import EducationAndDevelopment from '../pages/innovation/education-and-development';
import NaicsCodes from '../pages/innovation/naics-codes';

// Data Portal
import DataPortal from '../pages/data-portal/index';
import DataPortalHowItWorks from '../pages/data-portal/how-it-works';

// Our Approach
import OurApproach from '../pages/our-approach/index';
import DataGovernanceAndCompliance from '../pages/our-approach/data-governance-and-compliance';
import InnovationResearchAndDevelopment from '../pages/our-approach/innovation-research-and-development';
import OurCapabilities from '../pages/our-approach/our-capabilities';
import { Routes, Route } from 'react-router-dom';

// Orphan Pages
import Error404 from '../pages/error-404';
import Privacy from '../pages/privacy-policy/index';

const MainRoute = () => {
  return (
    <Routes>
      {/* Main routes */}
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/components" element={<Components />} />

      {/* Components routes */}
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/about-us/careers" element={<Careers />} />
      <Route path="/about-us/media" element={<Media />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/contact-us/success" element={<ContactUsSuccess />} />

      {/* Industries routes */}
      <Route path="/industries" element={<Industries />} />
      <Route path="/industries/government" element={<Government />} />
      <Route path="/industries/commercial" element={<Commercial />} />
      <Route
        path="/industries/commercial/researchers"
        element={<Researchers />}
      />
      <Route
        path="/industries/commercial/insurance-and-payers"
        element={<InsuranceAndPayers />}
      />
      <Route
        path="/industries/commercial/pharmaceuticals"
        element={<Pharmaceuticals />}
      />
      <Route
        path="/industries/commercial/custom-informatics"
        element={<CustomInformatics />}
      />
      <Route
        path="/industries/commercial/sports-medicine"
        element={<SportsMedicine />}
      />
      <Route
        path="/industries/government/bioinformatics"
        element={<Bioinformatics />}
      />
      <Route
        path="/industries/government/public-health-and-policy"
        element={<PublicHealthPolicy />}
      />
      <Route
        path="/industries/government/national-security"
        element={<NationalSecurity />}
      />
      <Route
        path="/industries/government/public-sector-solutions"
        element={<PublicSectorSolutions />}
      />

      {/* Innovation routes */}
      <Route path="/innovation" element={<Innovation />} />
      <Route path="/innovation/curo46" element={<Curo46 />} />
      <Route path="/innovation/curosygnal" element={<CuroSygnal />} />
      <Route path="/innovation/syn46" element={<Syn46 />} />
      <Route
        path="/innovation/edtech-and-professional-development"
        element={<EducationAndDevelopment />}
      />
      <Route path="/innovation/naics-codes" element={<NaicsCodes />} />

      {/* Data Portal routes */}
      <Route path="/data-portal" element={<DataPortal />} />
      <Route
        path="/data-portal/how-it-works"
        element={<DataPortalHowItWorks />}
      />

      {/* Our Approach routes */}
      <Route path="/our-approach" element={<OurApproach />} />

      <Route
        path="/our-approach/data-governance-and-compliance"
        element={<DataGovernanceAndCompliance />}
      />
      <Route
        path="/our-approach/innovation-research-and-development"
        element={<InnovationResearchAndDevelopment />}
      />
      <Route
        path="/our-approach/our-capabilities"
        element={<OurCapabilities />}
      />

      <Route path="/privacy-policy" element={<Privacy />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default MainRoute;
